import { render, staticRenderFns } from "./MessageBoardIndex.vue?vue&type=template&id=5e8d1f03&"
import script from "./MessageBoardIndex.vue?vue&type=script&lang=js&"
export * from "./MessageBoardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports